import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationIntegrationAuthorizeArgs, BackendUser } from 'src/types/backend';

const MUTATION = gql`
  mutation IntegrationAuthorize(
    $customerId: ID!
    $dataSource: PerformanceCenterDataSource!
    $credentials: CredentialsInput!
  ) {
    integrationAuthorize(
      customerId: $customerId
      dataSource: $dataSource
      credentials: $credentials
    ) {
      id
    }
  }
`;

type Variables = BackendMutationIntegrationAuthorizeArgs;
type Result = Pick<BackendUser, 'id'>;

export const integrationAuthorize = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
